import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../../services/api.service';

@Component({
  selector: 'my-category',
  template: require('./category.component.html')
})
export class CategoryComponent {

  public categoria = {};
  public listProductos = [];

  constructor(private _apiService:ApiService, private _activatedRoute: ActivatedRoute, private _router: Router) {
    this._activatedRoute.params.subscribe(params => {
      this._apiService.getCategory(params['id']).subscribe(
        result=>{
          this.categoria = result[0];
          this._apiService.getAllProductosByCategory(params['id']).subscribe(
            result=>{
              this.listProductos = result;
            }
          );
        },
        err => {
          console.log(err);
          this._router.navigateByUrl('404');
        }
      );
    })
  }
}
/**
 * Created by Desarrollo KJ on 20/3/2017.
 */



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/category/category.component.ts